"use client";

import { ConvexProvider, ConvexReactClient } from "convex/react";
import type { ReactNode } from "react";
import { SessionProvider } from "@/hooks/use-session";

// RU ISPs throttle Cloudflare ranges, and convex.cloud is fronted by
// Cloudflare — direct browser WebSockets to it stall from Russian networks
// even though mint24.net itself (Moscow VPS) loads instantly. On mint24.net
// we therefore talk to a same-origin /convex path that Caddy on the VPS
// relays to convex.cloud over clean datacenter egress. convex-js builds all
// endpoint URLs by string concatenation, so the path prefix survives:
// wss://mint24.net/convex/api/<version>/sync. No trailing slash here.
function resolveConvexUrl(): string {
  const direct = process.env.NEXT_PUBLIC_CONVEX_URL as string;
  if (typeof window === "undefined") return direct;
  const { hostname, origin } = window.location;
  if (hostname === "mint24.net" || hostname.endsWith(".mint24.net")) {
    return `${origin}/convex`;
  }
  return direct;
}

const convex = new ConvexReactClient(resolveConvexUrl(), {
  // The proxy URL is not a *.convex.cloud address; opt out of deployment-URL
  // validation so future convex-js versions can't break the relay.
  skipConvexDeploymentUrlCheck: true,
});

export function ConvexClientProvider({ children }: { children: ReactNode }) {
  return (
    <ConvexProvider client={convex}>
      <SessionProvider>{children}</SessionProvider>
    </ConvexProvider>
  );
}
